import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getClinicGeneralServiceMasterByClinicId = createAsyncThunk(
  "clinicGeneralServiceMaster/getClinicGeneralServiceMasterByClinicId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clinicGeneralServiceMaster/getClinicGeneralServiceMasterByClinicId",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const updateClinicGeneralServiceDetails = createAsyncThunk(
  "clinicGeneralServiceMaster/updateClinicGeneralServiceDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicGeneralServiceMaster/updateClinicGeneralServiceDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteClinicGeneralServiceDetails = createAsyncThunk(
  "clinicGeneralServiceMaster/deleteClinicGeneralServiceDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicGeneralServiceMaster/deleteClinicGeneralServiceDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  clinicGeneralServiceMasterByClinicId: [],
  updateClinicGeneralServiceDetailsSuccessMessage: null,
  updateClinicGeneralServiceDetailsErrorMessage: null,
  deleteClinicGeneralServiceDetailsSuccessMessage: null,
  deleteClinicGeneralServiceDetailsErrorMessage: null
};
const clinicGeneralServiceMasterSlice = createSlice({
  name: "clinicGeneralServiceMaster",
  initialState,
  reducers: {
    resetUpdateClinicGeneralServiceDetailsMessage: (state) => {
      state.updateClinicGeneralServiceDetailsSuccessMessage = null
      state.updateClinicGeneralServiceDetailsErrorMessage = null
    },
    resetDeleteClinicGeneralServiceDetailsMessage: (state) => {
      state.deleteClinicGeneralServiceDetailsSuccessMessage = null
      state.deleteClinicGeneralServiceDetailsErrorMessage = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClinicGeneralServiceMasterByClinicId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getClinicGeneralServiceMasterByClinicId.fulfilled, (state, action) => {
        state.loading = false;
        state.clinicGeneralServiceMasterByClinicId = action.payload.result.list;
      }
      )
      .addCase(getClinicGeneralServiceMasterByClinicId.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateClinicGeneralServiceDetails.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateClinicGeneralServiceDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateClinicGeneralServiceDetailsErrorMessage = action.payload.result.message;
        } else {
          state.updateClinicGeneralServiceDetailsSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateClinicGeneralServiceDetails.rejected, (state, action) => {
        state.loading = false;
        state.updateClinicGeneralServiceDetailsErrorMessage = action.payload;
      })
      .addCase(deleteClinicGeneralServiceDetails.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteClinicGeneralServiceDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteClinicGeneralServiceDetailsErrorMessage = action.payload.result.message;
        } else {
          state.deleteClinicGeneralServiceDetailsSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(deleteClinicGeneralServiceDetails.rejected, (state, action) => {
        state.loading = false;
        state.deleteClinicGeneralServiceDetailsErrorMessage = action.payload;
      });
  },
});

export const {
  resetUpdateClinicGeneralServiceDetailsMessage,
  resetDeleteClinicGeneralServiceDetailsMessage
} = clinicGeneralServiceMasterSlice.actions;

export default clinicGeneralServiceMasterSlice.reducer;
